import React, { Component } from "react";
import { getAvatarUrl } from "../../common/avatarStore";
import TickIcon from "../../resources/icons-check-circle-fill.svg";
import VacancyIcon from "../../resources/icons-user.svg";
import WarningIcon from "../../resources/icons-warning-circle-fill.svg";
import OrgChartNode from "./OrgChartNode";

// Inline styles for renderToStaticMarkup compatibility (MUI v6)
const styles = {
  stack: {
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    width: "100%",
  },
  profilePicWrapper: {
    position: "relative" as const,
    width: "40px",
    height: "40px",
  },
  avatar: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    backgroundColor: "var(--prussian-blue-pb-500)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontSize: "16px",
    overflow: "hidden",
  },
  avatarImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover" as const,
  },
  complianceBadge: {
    position: "absolute" as const,
    bottom: "0",
    right: "1px",
    width: "16px",
    height: "16px",
  },
  textOverflow: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    padding: "0 16px",
    whiteSpace: "nowrap" as const,
    width: "100%",
    boxSizing: "border-box" as const,
  },
  nameText: {
    fontWeight: 600,
    fontSize: "16px",
    marginTop: "16px",
    lineHeight: "24px",
    letterSpacing: "-0.1px",
  },
  jobText: {
    fontWeight: 400,
    lineHeight: "24px",
    color: "var(--grey-gr-500)",
  },
};

export default class OrgChartPersonNode extends Component<any, any> {
  static defaultProps = {
    type: "person",
  };

  constructor(props: any) {
    super(props);

    this.state = {};
  }

  renderAvatar() {
    const { data } = this.props;
    // Loaded by OrgChart, which redraws when it arrives; initials until then.
    const src = data?.hasProfilePicture ? getAvatarUrl(data.employeeId) : null;

    if (!data || data.isVacancy) {
      return (
        <div style={styles.avatar}>
          <VacancyIcon />
        </div>
      );
    }

    if (src) {
      return (
        <div style={styles.avatar}>
          <img src={src} alt={data.fullName} style={styles.avatarImg} />
        </div>
      );
    }

    return (
      <div style={styles.avatar}>
        {data.getInitials ? data.getInitials() : ""}
      </div>
    );
  }

  renderComplianceBadge() {
    const { data } = this.props;
    const showCompliance = !data.isVacancy && data.isMyTeam;

    if (!showCompliance) return null;

    return (
      <div className="klayo_profilepic_badge" style={styles.complianceBadge}>
        {data.isCompliant ? (
          <TickIcon style={{ width: "16px", height: "16px" }} />
        ) : (
          <WarningIcon style={{ width: "16px", height: "16px" }} />
        )}
      </div>
    );
  }

  render() {
    const { data, focused, inHighlightPath } = this.props;

    return (
      <OrgChartNode
        height={152}
        focused={focused}
        inHighlightPath={inHighlightPath}
        moreButton={true}
      >
        <div style={styles.stack}>
          <div
            className={
              "klayo_profilepic klayo_profilepic--size-sm" +
              (!data || data.isVacancy ? " klayo_profilepic-vacancy" : "")
            }
            style={styles.profilePicWrapper}
          >
            {this.renderAvatar()}
            {this.renderComplianceBadge()}
          </div>
          <div
            className="klayo-textoverflow"
            style={{ ...styles.textOverflow, ...styles.nameText }}
          >
            {data.isVacancy ? "Vacancy" : data.fullName}
          </div>
          <div
            className="klayo-textoverflow"
            style={{ ...styles.textOverflow, ...styles.jobText }}
          >
            {data.jobTitle}
          </div>
        </div>
      </OrgChartNode>
    );
  }
}
